import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * FeatureBadge - Reusable badge component for Free/Premium/Coming Soon indicators
 * @param {string} type - 'free' | 'premium' | 'coming'
 * @param {object} sx - Additional MUI sx styles
 */
function FeatureBadge({ type = 'free', sx = {} }) {
  const { t } = useTranslation();

  const variants = {
    free: {
      label: t('common.badgeFree'),
      color: 'success',
      sx: {
        bgcolor: 'rgba(102, 187, 106, 0.15)',
        color: '#66bb6a',
        border: '1px solid rgba(102, 187, 106, 0.3)',
        fontWeight: 600,
        fontSize: '0.75rem',
        letterSpacing: '0.5px',
      }
    },
    premium: {
      label: t('common.badgePremium'),
      color: 'primary',
      sx: {
        bgcolor: 'rgba(144, 202, 249, 0.15)',
        color: '#90caf9',
        border: '1px solid rgba(144, 202, 249, 0.3)',
        fontWeight: 600,
        fontSize: '0.75rem',
        letterSpacing: '0.5px',
      }
    },
    coming: {
      label: t('common.badgeComingSoon'),
      color: 'warning',
      sx: {
        bgcolor: 'rgba(255, 167, 38, 0.15)',
        color: '#ffa726',
        border: '1px solid rgba(255, 167, 38, 0.3)',
        fontWeight: 600,
        fontSize: '0.75rem',
        letterSpacing: '0.5px',
      }
    }
  };

  const variant = variants[type] || variants.free;

  return (
    <Chip
      label={variant.label}
      size="small"
      sx={{
        ...variant.sx,
        ...sx,
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'scale(1.05)',
        }
      }}
    />
  );
}

export default FeatureBadge;
